import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "table-accordion-body pt-4" }
const _hoisted_2 = { class: "row mb-1 w-100" }
const _hoisted_3 = { class: "col-3 d-flex" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "mt-4" }, [
  /*#__PURE__*/_createElementVNode("hr")
], -1)
const _hoisted_5 = { class: "mt-4" }
const _hoisted_6 = { class: "col-3 d-flex" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { class: "mt-4" }
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = {
  key: 1,
  class: "px-3"
}
const _hoisted_11 = { class: "col-3 d-flex" }
const _hoisted_12 = { class: "row py-4 my-2 align-items-center" }
const _hoisted_13 = { class: "col-6" }
const _hoisted_14 = { class: "secondary-text" }
const _hoisted_15 = { class: "col-6" }
const _hoisted_16 = { class: "d-flex align-items-center justify-content-end" }
const _hoisted_17 = { class: "ms-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EsimProfilesPackageBlock = _resolveComponent("EsimProfilesPackageBlock")!
  const _component_Country = _resolveComponent("Country")!
  const _component_Checklist = _resolveComponent("Checklist")!
  const _component_Btn = _resolveComponent("Btn")!
  const _component_Card = _resolveComponent("Card")!
  const _component_PackageProgress = _resolveComponent("PackageProgress")!
  const _component_PackageDataProgress = _resolveComponent("PackageDataProgress")!
  const _component_SettingsItem = _resolveComponent("SettingsItem")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_EsimProfilesPackageBlock),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_Card, { title: "Coverage area" }, {
            footer: _withCtx(() => [
              _createVNode(_component_Btn, {
                type: "primary-transparent",
                size: "md-fluid"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Show all ")
                ]),
                _: 1
              })
            ]),
            default: _withCtx(() => [
              _createVNode(_component_Country, {
                id: "esp",
                name: "Spain",
                description: "Supported with 3 carriers"
              }),
              _hoisted_4,
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_Checklist, { list: _ctx.coverageRegions }, null, 8, ["list"])
              ])
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_Card, { title: "PACKAGE USAGE" }, {
            footer: _withCtx(() => [
              _createVNode(_component_Btn, {
                type: "danger-transparent",
                size: "md-fluid",
                class: "mt-2"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Remove ")
                ]),
                _: 1
              })
            ]),
            default: _withCtx(() => [
              (_ctx.usageInfo.length > 1)
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.usageInfo, (usage) => {
                      return (_openBlock(), _createBlock(_component_PackageProgress, {
                        key: usage.id,
                        type: usage.type,
                        count: usage.count,
                        total: usage.total,
                        description: usage.description,
                        class: "mt-2"
                      }, null, 8, ["type", "count", "total", "description"]))
                    }), 128)),
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("small", {
                        class: "secondary-text text-center d-block",
                        innerHTML: _ctx.validTill
                      }, null, 8, _hoisted_9)
                    ])
                  ]))
                : (_ctx.usageInfo.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                      _createVNode(_component_PackageDataProgress, {
                        total: _ctx.getBalanceTotal,
                        count: _ctx.getBalanceCount,
                        description: _ctx.validitiTill,
                        unit: _ctx.usageInfo[0].unit
                      }, null, 8, ["total", "count", "description", "unit"])
                    ]))
                  : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createVNode(_component_Card, { title: "Options" }, {
            default: _withCtx(() => [
              _createVNode(_component_SettingsItem, {
                id: `eSIM:${_ctx.id}-free-socials`,
                modelValue: _ctx.freeSocials,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.freeSocials) = $event)),
                title: "FREE Socials",
                description: "Facebook, Instagram, WhatsApp, Messenger, Viber, Telegram"
              }, null, 8, ["id", "modelValue"])
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_12, [
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("p", _hoisted_14, " eSIM Profile is active from " + _toDisplayString(_ctx.getFormatDateActiveFrom) + " GMT ", 1)
      ]),
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("div", null, [
            _createVNode(_component_Btn, {
              type: "primary-transparent",
              size: "sm"
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Installation Instructions ")
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_17, [
            _createVNode(_component_Btn, {
              type: "danger-transparent",
              size: "sm"
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Delete eSIM Profile ")
              ]),
              _: 1
            })
          ])
        ])
      ])
    ])
  ], 64))
}